import { ShieldCheck, Building2, Award, Users } from "lucide-react";

export default function AboutPage() {
  return (
    <div className="mx-auto max-w-[1400px] px-6 md:px-10 py-16 md:py-20">
      <div className="grid md:grid-cols-12 gap-12 items-start">
        <div className="md:col-span-7">
          <div className="text-[10px] uppercase tracking-[0.28em] text-slate-500">About Mead</div>
          <h1 className="font-display text-4xl md:text-6xl tracking-tighter font-semibold mt-3">
            A field-services company built for compliance-first institutions.
          </h1>
          <div className="prose prose-slate max-w-none mt-8 text-slate-600 leading-relaxed">
            <p>
              Mead Property Preservation LLC was founded in 2011 by field
              technicians who had spent a decade watching servicers wrestle with
              inconsistent vendor networks. Our thesis was simple: institutional
              clients don&apos;t just need a service performed — they need a
              defensible packet delivered on time, every time.
            </p>
            <p>
              Today we operate across New Jersey and Pennsylvania with a mix of full-time crews
              and vetted subcontractors, all trained on the same photo protocol,
              chain-of-custody workflow, and client portal.
            </p>
            <p>
              We are HUD- and FHA-aligned, work directly with GSE-approved
              servicers, and provide portfolio-scale SLAs to regional banks,
              national asset managers, and mortgage originators.
            </p>
          </div>
        </div>
        <div className="md:col-span-5">
          <div className="border border-slate-200 divide-y divide-slate-200">
            <Item icon={ShieldCheck} title="Licensed &amp; insured" body="$2M general liability. Workers comp in all operating states." />
            <Item icon={Building2} title="Est. 2011" body="Over a decade of continuous P&amp;P operations." />
            <Item icon={Award} title="Compliance-first" body="HUD/FHA aligned photo protocol. GSE-servicer approved workflows." />
            <Item icon={Users} title="70+ crew members" body="Full-time employees plus vetted regional subcontractors." />
          </div>
        </div>
      </div>
    </div>
  );
}

function Item({ icon: Icon, title, body }) {
  return (
    <div className="p-5 flex gap-4">
      <div className="h-10 w-10 flex items-center justify-center bg-[#0B192C] text-white shrink-0">
        <Icon className="h-5 w-5" strokeWidth={2} />
      </div>
      <div>
        <div className="font-display text-lg tracking-tight" dangerouslySetInnerHTML={{ __html: title }} />
        <div className="text-sm text-slate-600 mt-1" dangerouslySetInnerHTML={{ __html: body }} />
      </div>
    </div>
  );
}
